import React, { Component } from 'react';
import { connect } from "react-redux";
import {Button, FormGroup, Col, Input} from 'reactstrap';
import 'Assets/Reports/reportsDefinitions.css';
import ErrorGif from 'Assets/images/Error.gif';

class EditName extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modal_close: false,
            error_msg:false,
            ReportName: '',
            ReportId: ''
        };
         
        if (this.props.parentToChildData && this.props.parentToChildData.length > 1) {
            this.state.ReportName = this.props.parentToChildData[0];
            this.state.ReportId = this.props.parentToChildData[1];
        }    

        this.closeWindow = this.closeWindow.bind(this);
        this.saveChange = this.saveChange.bind(this);
    }

    closeWindow() {  this.props.toggleEditName();  }

    saveChange() {
        document.getElementById('dupError').style.display = 'none';
        document.getElementById('illegalCharError').style.display = 'none';
        document.getElementById('tooManyCharacters').style.display = 'none';
        var intrptId = parseInt(this.state.ReportId);
        var revisedName = this.state.ReportName.trim().toLowerCase();
        var rEx = '^[a-zA-Z0-9_.,() $:!&-]*$';

        if (revisedName.length > 50) {
            document.getElementById('tooManyCharacters').style.display = 'block';
        } else if (revisedName.match(rEx) !== null) {
            const found = this.props.ReportsList.find(element => element.name.toLowerCase()  === revisedName && element.id !== intrptId);
          
            if (!found)
                this.props.UpdateName(this.state.ReportName, this.state.ReportId);
            else 
                document.getElementById('dupError').style.display = 'block';
        } else {
            document.getElementById('illegalCharError').style.display = 'block';
        }
    }

    render() {
        let labelText = this.props.getLabels;

        return (
            <div style={{padding:'10px'}}> 
                <div style={modal_title}>{labelText['EditName.Text'] !== undefined ? labelText['EditName.Text'] : "Edit Name"}</div>
                <div id='dupError' style={{display: 'none', color:'red', fontWeight: 'bold'}}><img src={ErrorGif} alt="Error" /> {labelText['ReportManagement.DuplicateValidationerror.Text'] !== undefined ? labelText['ReportManagement.DuplicateValidationerror.Text'] : "Error: Report Name already exists."}</div>
                <div id='illegalCharError' style={{display: 'none', color:'red', fontWeight: 'bold'}}><img src={ErrorGif} alt="Error" /> {labelText['ReportManagement.IllegalCharError.Text'] !== undefined ? labelText['ReportManagement.IllegalCharError.Text'] : "Error: Report Name contains characters other than letters and numbers."}</div>
                <div id='tooManyCharacters' style={{display: 'none', color:'red', fontWeight: 'bold'}}><img src={ErrorGif} alt="Error" /> {labelText['ReportManagement.OverMax.Text'] !== undefined ? labelText['ReportManagement.OverMax.Text'] : "Error: The text has over the maximum number of characters allowed."}</div>
                
                <div style={{paddingTop: '10px'}}>
                    <div style={modal_subTitle}>{labelText['ManageReportDefinition.Columns.Name.Text'] !== undefined ? labelText['ManageReportDefinition.Columns.Name.Text'] : "Name"}</div>
                    <div style={modal_entry}>
                        <Input className="customInput default-input" type="text" maxLength="50" name="Name" ref="asdf" defaultValue={this.state.ReportName} onChange={e => this.setState({ ReportName: e.target.value })} />
                        <span style={modal_hint}>{labelText['ReportManagement.MaxCharacters50.Text']}</span>
                    </div>
                </div>
                <FormGroup row >
                    <Col sm={12} style={{textAlign:'right', padding: '0px'}}>
                        <Button className="btn-md ChangeLimits_Cancelbtn" style={{marginRight: '10px'}} onClick={this.closeWindow}>{labelText['Buttons.Cancel.Text'] !== undefined ? labelText['Buttons.Cancel.Text'] : "Cancel"} </Button>
                        <Button className="btn-success" style={{marginRight: '4px'}} onClick={this.saveChange}>{labelText['Apply.Text'] !== undefined ? labelText['Apply.Text'] : "Apply"} </Button>
                    </Col>
                </FormGroup>
            </div>
        );
    }
}

const modal_title ={
    fontFamily:'Arial-BoldMT,Arial Bold, Arial',
    fontWeight:'bold',
    fontSize: '18px',
    textAlign: 'left',
    paddingBottom: '10px'
}

const modal_subTitle = {
    fontSize: '14px',
    width:'20%',
    fontWeight: '700',
    fontFamily: 'Verdana',
    verticalAlign: 'middle',
    float: 'left'
}

const modal_entry = {
    width:'75%', 
    float: 'right',
    marginBottom: '30px'
}

const modal_hint = {
    fontSize: '11px',
    fontStyle: 'italic'
}

const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.ReportMgmt_LabelsBasedOnPreference,
    };
};

export default connect(mapStateToProps)(EditName);
